import { UUID } from 'angular2-uuid';
import { BehaviorSubject } from 'rxjs';

export class ClientHelper {
    public static ClientID = UUID.UUID();
    public static StartUpCompleted: BehaviorSubject<boolean> = new BehaviorSubject(false);
}
